import { useEffect, useRef, useState } from 'react';
import './filter.css';
import StyledRange from '../range';
import { priceRangeValue } from '../../dummyData/config';
import { fetchFiltersData } from '../../pages/searchResult/searchResultFun/fetchFilters';
import Tooltip from '../tooltip/Tooltip';
import { ReactComponent as InfoI } from '../../assets/icons/trvto_info.svg';

export default function Filters({ filterData, onFilterChange, className, prevFilters, type, selectedChipFilter }) {
    const [openIndex, setOpenIndex] = useState(null);
    const [dropdownData, setDropdownData] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState({});
    const [rangeValues, setRangeValues] = useState([priceRangeValue[0], priceRangeValue[1]]);
    const [maxDays, setMaxDays] = useState('');
    const [maxNights, setMaxNights] = useState('');
    const isUserActionRef = useRef(false);

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    useEffect(() => {
        const filters = prevFilters || {};

        const range = filters.priceRange
            ? filters.priceRange.map(Number).sort((a, b) => a - b)
            : [priceRangeValue[0], priceRangeValue[1]];

        setSelectedFilters(filters);
        setRangeValues(range);
        setMaxDays(filters.maxDays || '');
        setMaxNights(filters.maxNights || '');
    }, [prevFilters]);

    // useEffect(() => {
    //     setTypeSel((prev) => prev);
    // }, []);

    useEffect(() => {
        fetchFiltersData(type, setDropdownData);
    }, [type]);

    const handleCheckboxChange = (type, value) => {
        isUserActionRef.current = true;
        const filterType = getType(type);

        setSelectedFilters((prev) => {
            const updated = { ...prev };

            if (!updated[filterType]) {
                updated[filterType] = [];
            }

            // Remove "All" when working with base_city
            if (filterType === 'base_city') {
                updated[filterType] = updated[filterType].filter((item) => item !== 'All');
            }

            if (updated[filterType].includes(value)) {
                updated[filterType] = updated[filterType].filter((item) => item !== value);
            } else {
                updated[filterType].push(value);
            }

            return updated;
        });
    };

    const handleRangeChange = (values) => {
        isUserActionRef.current = true;
        const numericValues = values.map(Number);

        setRangeValues(numericValues);

        setSelectedFilters((prev) => ({
            ...prev,
            priceRange: numericValues
        }));
    };

    const handleDaysChange = (e, value) => {
        isUserActionRef.current = true;
        if (value === 'max_days') {
            setMaxDays(e.target.value);
            setSelectedFilters((prev) => ({
                ...prev,
                maxDays: e.target.value
            }));
        } else if (value === 'max_nights') {
            setMaxNights(e.target.value);
            setSelectedFilters((prev) => ({
                ...prev,
                maxNights: e.target.value
            }));
        }
    };

    const handleClearFilters = () => {
        // setRangeValues([priceRangeValue[0], priceRangeValue[1]]);
        // setMaxDays('');
        // setMaxNights('');
        // setSelectedFilters({});
        onFilterChange({});
    };

    useEffect(() => {
        if (!selectedChipFilter) return;

        isUserActionRef.current = true;

        setSelectedFilters((prev) => ({
            ...prev,
            base_city: selectedChipFilter === 'All' ? [] : [selectedChipFilter]
        }));
    }, [selectedChipFilter]);

    useEffect(() => {
        if (!isUserActionRef.current) return;
        onFilterChange(selectedFilters);
        isUserActionRef.current = false;
    }, [selectedFilters]);

    const getType = (type) => {
        if (type === 'Base Cities') {
            return 'base_city';
        } else if (type === 'Destination') {
            return 'Destination';
        } else if (type === 'Difficulty') {
            return 'Difficulty';
        } else if (type === 'Types/Categories') {
            return 'type';
        } else if (type === 'Dates') {
            return 'Dates';
        } else if (type === 'Group') {
            return 'Group';
        } else if (type === 'Room Type') {
            return 'room_type';
        }
    };
    console.log(rangeValues);
    console.log(typeof rangeValues[0]);
    console.log(typeof rangeValues[1]);
    return (
        <div className={`filterDiv ${className}`} key={JSON.stringify(selectedFilters)}>
            <div className='alignCenter'>
                <h2 className='filter'>FILTERS</h2>
                <button className='btn' onClick={handleClearFilters}>
                    Clear
                </button>
            </div>
            <div style={{ marginTop: '18px' }}>
                {dropdownData.map((dropdown, dropdownIndex) => (
                    <div key={`dropdown-${dropdownIndex}`}>
                        <div
                            className='accordion-header'
                            onClick={() => toggleAccordion(filterData.length + dropdownIndex)}
                        >
                            <div className='filterTypeHeading alignCenter'>
                                <span className='accordion-filter-header-text'>
                                    <p>{dropdown?.heading === 'Base Cities' ? 'Start Cities' : dropdown?.heading}</p>
                                    {dropdown?.heading === 'Base Cities' ? (
                                        <Tooltip content='Choose a start point for your travel' position='top'>
                                            <span className='eyeIcon'>
                                                <InfoI color='blue' width={15} height={15} />
                                            </span>
                                        </Tooltip>
                                    ) : dropdown?.heading === 'Difficulty' ? (
                                        <Tooltip
                                            content='Select how challenging your trip should be (Easy, Medium, Hard)'
                                            position='top'
                                        >
                                            <span className='eyeIcon'>
                                                <InfoI color='blue' width={15} height={15} />
                                            </span>
                                        </Tooltip>
                                    ) : null}
                                </span>
                                <span className='accordion-icon'>
                                    {openIndex === filterData.length + dropdownIndex ? '-' : '+'}
                                </span>
                            </div>
                        </div>
                        <div
                            style={{
                                display: openIndex === filterData.length + dropdownIndex ? 'block' : 'none',
                                paddingBottom: '20px'
                            }}
                        >
                            {dropdown.dropdown.map((item, itemIndex) => (
                                <div key={`dropdown-item-${itemIndex}`} className='filterSubTypeDiv'>
                                    <input
                                        className='filterSubTypeCheck'
                                        type='checkbox'
                                        onChange={() => handleCheckboxChange(dropdown.heading, item.name)}
                                        checked={
                                            selectedFilters[getType(dropdown.heading)]?.includes(item.name) || false
                                        }
                                    />
                                    <p className='filterSubTypeName'>{item.displayName || item.name}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
                {filterData?.map((filter, filterIndex) => (
                    <div key={filterIndex}>
                        <div className='accordion-header' onClick={() => toggleAccordion(filterIndex)}>
                            <p className='filterTypeHeading alignCenter'>
                                {filter.heading}
                                <span className='accordion-icon'>{openIndex === filterIndex ? '-' : '+'}</span>
                            </p>
                        </div>
                        <div
                            style={{
                                display: openIndex === filterIndex ? 'block' : 'none',
                                paddingBottom: '20px'
                            }}
                        >
                            {filter.type === 'checkbox' &&
                                filter.subType?.map((type, typeIndex) => (
                                    <div key={typeIndex} className='filterSubTypeDiv'>
                                        <input
                                            className='filterSubTypeCheck'
                                            type='checkbox'
                                            onChange={() => handleCheckboxChange(filter.heading, type)}
                                            checked={selectedFilters[filter.heading]?.includes(type) || false}
                                        />
                                        <p className='filterSubTypeName'>{type}</p>
                                    </div>
                                ))}
                            {filter.type === 'range' && (
                                <div style={{ margin: '0 8px' }}>
                                    <StyledRange
                                        step={1000}
                                        value={[...rangeValues].sort((a, b) => a - b)}
                                        min={priceRangeValue[0]}
                                        max={priceRangeValue[1]}
                                        onChange={handleRangeChange}
                                    />
                                </div>
                            )}
                            {filter.type === 'number' && (
                                <input
                                    value={filter.value === 'max_days' ? maxDays : maxNights}
                                    className='numberField'
                                    type='number'
                                    placeholder={`Enter ${filter.heading}`}
                                    onChange={(e) => handleDaysChange(e, filter.value)}
                                />
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
